import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {ContactActionPopover} from '/component/partial/profile/ContactActionPopover';
import {
  accountEmailById,
  firstNameById,
  lastNameById,
  phoneNumberById,
} from '/redux/selector/client.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      firstName: firstNameById,
      lastName: lastNameById,
      phoneNumber: phoneNumberById,
      accountEmail: accountEmailById,
    }),
  ),
)(ContactActionPopover);
